export const metaTags = {
  metaTitle: "Best Online Auctions",
  metaDescription:
    "Auctions, Buy Now, Make an Offer - BIDS.COM Engagement Rings, Gold and Diamond Jewelry, Jewellery, Watches, Designer Bags, Clothing, Shoes, Sunglasses, Accessories, Arts Ring - Necklace - Earrings - Panting - Watches - Shoes - Clothing - Sunglasses - Accessories - Bags Free Shipping and Discount Options Available",
  image:
    "https://cdn.shopify.com/s/files/1/0071/2081/4195/files/Bids_Logo_Meta_cc7f2304-fe85-4e3e-96a6-c7b2845d7a37.png?v=1605511280",
};
